<template>
  <div id="mapa-financeiro" @click.stop>
    <div class="w3-row-padding row-mapa-financeiro">
      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div> 
      
      <div class="w3-card card-pedido-bloqueado" v-else v-cloak>
        <vue-tabs activeTabColor="#d4d4d4">
          <v-tab title="Itens">
            <div class="w3-container card-items card-interno" style="background-color: #d4d4d4; ">

              <div class="card-informacoes w3-container" v-for="(item, item_index) in items" :key="item_index">
                <div class="w3-col s12" >
                  <strong class="w3-text-theme">{{ item.nome_produto_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>CFOP id: </label>
                  <strong>{{ item.cfop_id }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Quantidade: </label>
                  <strong>{{ item.quantidade }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Quantidade XML: </label>
                  <strong>{{ item.quantidade_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Preço: </label>
                  <strong>{{ item.preco }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Valor produtos: </label>
                  <strong>{{ item.valor_produtos }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Desconto: </label>
                  <strong>{{ item.valor_desconto }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Outras despesas: </label>
                  <strong>{{ item.valor_outras_despesas }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Frete: </label>
                  <strong>{{ item.valor_frete }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>% IPI: </label>
                  <strong>{{ item.perc_ipi }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Valor IPI: </label>
                  <strong>{{ item.valor_ipi }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Situação trib. PIS: </label>
                  <strong>{{ item.situacao_trib_pis }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Base PIS: </label>
                  <strong>{{ item.base_pis }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>% PIS: </label>
                  <strong>{{ item.perc_pis }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Valor PIS: </label>
                  <strong>{{ item.valor_pis }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Situação trib. Cofins: </label>
                  <strong>{{ item.situacao_trib_cofins }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Base Cofins: </label>
                  <strong>{{ item.base_cofins }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>% Cofins: </label>
                  <strong>{{ item.perc_cofins }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Valor Cofins: </label>
                  <strong>{{ item.valor_cofins }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Marca: </label>
                  <strong>{{ item.marca }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Numero pedido: </label>
                  <strong>{{ item.numero_pedido }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Item id: </label>
                  <strong>{{ item.item_id }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Unidade XML: </label>
                  <strong>{{ item.unidade_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Código Ncm XML: </label>
                  <strong>{{ item.codigo_ncm_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Código barras XML: </label>
                  <strong>{{ item.codigo_barras_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Código produto XML: </label>
                  <strong>{{ item.codigo_produto_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Código origem Adm: </label>
                  <strong>{{ item.codigo_origem_adm }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Código origem XML: </label>
                  <strong>{{ item.codigo_origem_xml }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Local id: </label>
                  <strong>{{ item.local_id_padrao }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Peso: </label>
                  <strong>{{ item.peso }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Volume: </label>
                  <strong>{{ item.volume }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Indice unidade tributável: </label>
                  <strong>{{ item.indice_unidade_tributavel }}</strong>
                </div>
                
                <div class="w3-col s12" >
                  <label>Embalagem fracionada: </label>
                  <strong>{{ item.embalagem_fracionada_adm }}</strong>
                </div>
              </div>
            </div>            
          </v-tab>
          
          <v-tab title="Críticas" v-if="criticas">
            <div class="w3-container card-items card-interno" style="background-color: #d4d4d4; ">
              <div class="w3-row row-criticas-mobile">
                <div class="card-informacoes w3-col s12" :key="index" v-for="(critica, index) in criticas">
                
                  <div class="w3-col s12" >
                    <label>Status: </label>
                    <strong>{{ critica.status_critica }}</strong>
                  </div>
                  
                  <div class="w3-col s12" >
                    <label>Tipo: </label>
                    <strong>{{ critica.tipo_trava_analitico }}</strong>
                  </div>
                  
                  <div class="w3-col s12" >
                    <label>Crítica: </label>
                    <strong>{{ critica.critica }}</strong>
                  </div>
                </div>
                <br>
              </div>
            </div>  
          </v-tab>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import toastr from 'toastr'
  import RCompraBuscarComprasEmAbertoDashboard from '@/components/Rest/RCompra/RCompraBuscarComprasEmAbertoDashboard'
	
  export default {
    name: 'ModalItensXml',

    props: ['items', 'criticas'],

    mixins:[formatarValorMixin],

    data() {
      return {
        mostrar_items: false,
        api: process.env.API,
        processando: true,
      }
    },

    computed:{
      confirmarLiberado() {
        let lista = []
        for (let i = 0; i < this.resultado.itens.length; i++) {
          if (this.resultado.itens[i].quantidade == this.resultado.itens[i].quantidade_conferida) {
            lista.push(i);
          }
        }

        if (lista.length == this.resultado.itens.length) {
          return false;
        } 
        else {
          return true;
        }
      }
    },

    mounted() {
      this.processando = false;
    },

    methods: {
      mostrarItems(boolean) {
        this.mostrar_items = boolean;
      },

      atualizar() {
        this.$parent.buscarComprasEmAberto();
      },

      async buscarCompras() {
        try {
          let parametros = {
            tipo_operacao: 'DCP',
            compra_id: this.compra_id,
            motivo_cancelamento: ''
          }

          let retorno = await RCompraBuscarComprasEmAbertoDashboard.buscarComprasEmAbertoDashboard(this.axios, parametros);
          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.cabecalho = retorno.data.dados.detalhe_compra['0'];
          this.items = response.data.dados.itens_compra;
          this.prazos = response.data.dados.prazo_compra;
          this.processando = false;
        } 
        catch (error) {
          this.processando = false;
        }
      },

      abrirModalConferencia(){
        this.$root.$emit('abrirModalConferencia', this.resultado);
      }
    }
  }
</script>

<style scoped>
  .dados_mapa {
    margin-top: 20px;
  }

  .item-pre-confirmado{
    color: grey
  }

  .texto-responsivo {
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    hyphens: auto;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .row-mapa-financeiro{
    padding: 0 
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }
  
  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .card-portador {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-portador .w3-text-theme {
    text-transform: uppercase;
  }

  @media(max-width: 992px) {
    .dados_mapa.w3-row-padding {
      padding: 0 !important
    }

    .row-criticas-mobile {
      max-width: 100% !important
    }
    
    .box-contas {
      margin-bottom: 20px
    }

    .box-contas:last-child {
      margin-bottom: 0;
    }
  }

  @media(max-width: 500px) {
    .card-pedido-bloqueado .w3-row-padding {
      padding: 0
    }
  }

  @media(max-width: 645px) {
    .card-interno {
      padding-left: 3px !important;
      padding-right: 3px !important
    }
  }
  
  .row-criticas-mobile {
    max-width: 100%
  }
  
  .card-informacoes {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .btn-liberar {
    width: auto !important;
  }

  .w3-right {
    padding-left: 10px;
  }

  .items-mobile-info {
    float: right
  }

  .td-items {
    text-align: center
  }
  
  td, th {
    text-align: center
  }
  
  .vue-tabs {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ModalItensXml.vue